// src/components/Report/types.ts
/** 1 = Bulgu / tespit, 2 = Öneri. Eksik veya null = eski kayıt (bulgu ile aynı). */
export type QuestionAnswerAttachmentSection = 1 | 2;

export interface FileAttachment {
    id: string;
    fileName: string;
    attachmentSection?: QuestionAnswerAttachmentSection | null;
}

export interface ReportData {
    pinInfo: {
        Name: string;
        Sector: string;
        Latitude: number;
        Longitude: number;
        RadiusInMeters: number;
        reportDescription: string | null;
        fileAttachments: FileAttachment[];
        Id: string;
        reportLocationPng?: string | null; // Rapor için kaydedilmiş harita görüntüsü FileAttachment ID'si
        reportLocationSatellitePng?: string | null; // Uydu haritası PNG FileAttachment ID'si
        JsonContentStream?: {
            description?: string | null;
        };
    };
    questionAnswers: {
        answer: {
            questionId: string;
            questionText?: string;
            findings: string;
            proposedSolutions: string;
            description: string;
            questionCategoryName: string;
            fileAttachments: FileAttachment[];
        };
    }[];
    riskAnswers: {
        id: string;
        probabilityLevel: number;
        impactLevel: number;
        threatLevel: number;
        appliedMeasureCoefficient: number;
        residualRiskLevel: number;
        isAfterMeasures: boolean;
        categoryName: string;
        questionTypeName: string;
    }[];
}

/** Rapor PDF/DOCX içinde “onay ve versiyon” bloğu için metinler. */
export interface ReportWorkflowMeta {
    preparedBy: string;
    reviewerOrApprover: string;
    version: string;
    createdAtLabel: string;
}

export function buildReportWorkflowMeta(
    reportData: ReportData | null,
    userData: { firstName: string; lastName: string } | null,
): ReportWorkflowMeta {
    const pdfCount = (reportData?.pinInfo.fileAttachments ?? []).filter((f) =>
        (f.fileName ?? '').toLowerCase().endsWith('.pdf'),
    ).length;
    const prepared = userData ? `${userData.firstName} ${userData.lastName}`.trim() : '';
    return {
        preparedBy: prepared || '—',
        reviewerOrApprover:
            '— Onay süreci “Kaydedilen Raporlar” üzerinden yürütülür; onaylayan kişiler sistemde kayıtlıdır.',
        version: String(Math.max(1, pdfCount + 1)),
        createdAtLabel: new Date().toLocaleString('tr-TR', { dateStyle: 'long', timeStyle: 'short' }),
    };
}